import React from "react"

import { Box, Popover } from "@mui/material"

interface HoverPopoverProps {
  children: React.ReactElement<React.HTMLAttributes<HTMLElement>>
  content: React.ReactNode
  disableTypography?: boolean
}

export const HoverPopover: React.FC<HoverPopoverProps> = ({
  children,
  content,
  disableTypography,
}) => {
  const popoverId = React.useId()
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Box
        aria-describedby={open ? popoverId : undefined}
        aria-haspopup="true"
        component="span"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={{ display: "inline-flex" }}
      >
        {children}
      </Box>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        disableRestoreFocus
        id={popoverId}
        onClose={handlePopoverClose}
        open={open}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 300,
            },
          },
        }}
        sx={{
          pointerEvents: "none",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            fontSize: disableTypography ? undefined : "body2.fontSize",
            p: 1,
          }}
        >
          {content}
        </Box>
      </Popover>
    </>
  )
}
